/**
 * intl-tel-input Wrapper
 * Handles phone input initialization
 */

import { ErrorManager } from '../validation/error_manager.js';

export class IntlTelInputWrapper {
  /**
   * Initialize phone inputs
   */
  static init() {
    // Load CSS if not already loaded
    if (!document.querySelector('link[href*="intlTelInput.css"]')) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/css/intlTelInput.css';
      document.head.appendChild(css);
    }

    // Load JS if not already loaded
    if (!window.intlTelInput) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/js/intlTelInput.min.js';
      script.onload = () => {
        this.setupPhoneInputs();
      };
      document.head.appendChild(script);
    } else {
      this.setupPhoneInputs();
    }
  }

  /**
   * Setup phone inputs
   */
  static setupPhoneInputs() {
    const phoneInputs = document.querySelectorAll('.phone-input');
    
    phoneInputs.forEach(input => {
      if (input.itiInstance) return; // Already initialized

      const iti = window.intlTelInput(input, {
        initialCountry: 'auto',
        geoIpLookup: (callback) => {
          fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(data => callback(data.country_code))
            .catch(() => callback('us'));
        },
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/js/utils.js'
      });

      input.itiInstance = iti;

      // Helper function to update data-full-number whenever there's a value
      const updateFullNumber = () => {
        const fullNumber = iti.getNumber();
        if (fullNumber) {
          input.setAttribute('data-full-number', fullNumber);
        } else {
          input.removeAttribute('data-full-number');
        }
      };

      // Clear errors while typing and update full number if valid
      input.addEventListener('input', () => {
        ErrorManager.clearError(input);
        // Update data-full-number on input (debounced)
        clearTimeout(input._updateNumberTimeout);
        input._updateNumberTimeout = setTimeout(updateFullNumber, 300);
      });

      // Validate on blur and update full number
      input.addEventListener('blur', () => {
        if (input.value.trim() && !iti.isValidNumber()) {
          ErrorManager.showError(input, 'Enter valid phone number');
        } else {
          ErrorManager.clearError(input);
          // Update data-full-number on blur if valid
          updateFullNumber();
        }
      });

      // Store full number on country change
      input.addEventListener('countrychange', () => {
        updateFullNumber();
      });
    });
  }
}

